<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" [floatLabel]="floatLabel">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    <span>{{ label }}</span>
  </mat-label>

  <nimbus-mat-time-picker
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [timeFormat]="format"
    [disabled]="isDisabled"
    [required]="isRequiredControl"
    [errors]="ngControl.errors"
    [errorStateMatcher]="this"
    (touched)="propagateTouched()"
  ></nimbus-mat-time-picker>

  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>

  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (!isDisabled) {
    <i matSuffix [nimbusIcon]="icons.CLOCK_LIGHT" class="cursor-pointer"></i>
  }

  @if (isErrorState()) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }

  <mat-hint align="end" class="time-format">{{ format.toUpperCase() }}</mat-hint>
</mat-form-field>
